export default function Card({ title, description, onClick, children }) {
    return (
        <div className="page-card col-md-3 col-sm-6 nopadding" onClick={onClick}>
            <div className="page-card-inner">
                <div className="page-card-content">
                    <label>{title}</label>
                    {description?.toString()?.trim()?.length > 0 ? <p>{description}</p> : null}
                    {children}
                </div>
            </div>
        </div>
    );
}